import { mobileFeature } from "../../../../constants/mobileFeature";

const MobileFeature = () => {
  return (
    <section id="features">
      <div className="max-width-custom">
        <h1 className="text-center fs-56 py-4">
          DOXBOX Mobile Application Features
        </h1>
        <div className="container border-radius-20 border-custom">
          {mobileFeature.map((item, id) => (
            <div
              className={`row align-items-center justify-content-between mb-5 flex-column-reverse flex-md-row ${
                id % 2 !== 0 ? "flex-md-row-reverse" : ""
              }`}
              key={id}
            >
              {/* Image Column */}
              <div className="col-12 col-md-5 col-lg-5 d-flex justify-content-center">
                <div
                  className={`p-5 rounded-4 d-flex justify-content-center align-items-center mob-feat-bg ${
                    item.bgClass
                  }${id + 1} w-100`}
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    style={{ maxWidth: "250px", width: "100%", height: "auto" }}
                  />
                </div>
              </div>

              {/* Spacer (only for md and above) */}
              <div className="d-none d-md-block col-md-1 col-lg-1"></div>

              {/* Text Column */}
              <div className="col-12 col-md-6 col-lg-6 mob-right">
                <h4 className="mb-4 fw-semibold">{item.title}</h4>
                <p className="fs-6-mobile text-muted pb-3">{item.para1}</p>
                <p className="fs-6-mobile text-muted pb-3">{item.para2}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MobileFeature;
